import React from "react";

const StatusSuccess = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <defs>
      <path
        d="M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0zM7.608 15.528a1.068 1.068 0 001.495 0L17.15 7.61a1.027 1.027 0 000-1.472 1.068 1.068 0 00-1.495 0l-7.294 7.178-3.064-3.004a1.068 1.068 0 00-1.495 0 1.027 1.027 0 000 1.47l3.806 3.746z"
        id="prefix__a"
      />
    </defs>
    <use
      fill="#88C981"
      fillRule="nonzero"
      xlinkHref="#prefix__a"
      transform="translate(2 2)"
    />
  </svg>
);

export default StatusSuccess;
